import { ReactNode } from 'react';
import { LayoutContextProvider } from './layout/layout-context';
import { CurrentAudioPlayingProvider } from './current-audio-playing';

export default function PrivateProviders({ children }: { children: ReactNode }) {
  return (
    <LayoutContextProvider>
      <CurrentAudioPlayingProvider>{children}</CurrentAudioPlayingProvider>
    </LayoutContextProvider>
  );
}
